export const FIELDS = {
  CODE: 'code',
} as const;

/** Length of each of the two device-code chunks (backend format is `XXXX-XXXX`). */
export const CODE_CHUNK_LENGTH = 4;

// Unambiguous device-code alphabet — must match qodo-platform's DEVICE_CODE_PATTERN
// (`^[A-HJ-NP-Z2-9]{4}-[A-HJ-NP-Z2-9]{4}$`): excludes 0/1/I/O so codes read aloud cleanly.
// Case-insensitive here because the user may type lowercase; normalizeDeviceCode uppercases
// at submit. Validating client-side against the same alphabet avoids a confusing 422 from the
// platform when a user types an excluded char (e.g. O for 0).
const CODE_CHAR = '[A-HJ-NP-Za-hj-np-z2-9]';

/** Accepts `XXXX-XXXX` or the hyphen-less `XXXXXXXX`; the hyphen is re-inserted at submit. */
export const DEVICE_CODE_PATTERN = new RegExp(
  `^${CODE_CHAR}{${CODE_CHUNK_LENGTH}}-?${CODE_CHAR}{${CODE_CHUNK_LENGTH}}$`,
);
